import { Color } from './color';
/**
 * ○
 */
export const HollowPoint = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'point' }, options), context);
};
HollowPoint.props = Object.assign({ defaultMarker: 'hollowPoint' }, Color.props);
//# sourceMappingURL=hollow.js.map